<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>{{ message.Immunization }}</h1>
                    <p class="auth-subtext"></p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-form
                :model="formsData.userForm"
                :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)"
                :label-position="'top'"
                @submit.prevent="save('userForm')"
                @keyup.enter="save('userForm')"
                class="full_page"
            >
                <el-form-item class="immunization-banner">
                    <img :src="require('@/assets/img/illustrations/immunization.svg')" />
                    <span class="title">Are you able to Vaccinate?</span>
                </el-form-item>

                <div class="buttons-group">
                    <el-button type="blue" @click="setCovid(1)">
                        Yes
                    </el-button>
                    <el-button @click="setCovid(0)">
                        No
                    </el-button>
                </div>

            </el-form>

        </div>
    </div>
</template>

<script>

import {
    onMounted,
    inject,
} from "vue";

import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 


addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from "@ionic/vue";

import {useStore} from "vuex";
import {
    useRouter,
    useRoute,

} from "vue-router";
import formHooks from "@/hooks/form/form";

import isEmpty from "lodash/isEmpty";


export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },

    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute()
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const routeName = $route.name;
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const state = userData.address.state;
        const message = inject("messages");

        const formsDataArray = {
            userForm: {
                covid: {
                    data: [{value: '0', label: 'No'}, {value: '1', label: 'Yes'}],
                    value: userData.covid ? userData.covid :  0,
                },
            },
        };
        const goNext = () => {
            if (state == "VIC" || state == "Victoria") {
                if (routeName == "onboard_covid_status") {
                    $router.push({
                        name: "onboard_personal_cert",
                    });
                }else{
                    $router.push({
                        name: "personal_cert",
                    });
                }

            }else{
                if (routeName == "onboard_covid_status") {
                    $store.dispatch("ENABLE_MARKETPLACE_PROCESS_COMPLETE");
                    $store.dispatch("SAVE_USER_DATA", {
                        survey: 1,
                        hideLoading: true,
                    });
                    $router.push({
                        name: "onboard_intro",
                    });

                }else{
                    $store.dispatch("SAVE_USER_DATA", {
                        survey: 1,
                        hideLoading: true,
                    });
                    $router.push({
                        name: "intro",
                    });
                }
            }
        };

        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });
        };

        const setCovid = (value) => {
            formsData.userForm.covid.value = value
            save('userForm')
        };

        const save = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    try {
                        const data = getFormValues(formName);

                        if(isEmpty(data) ) {
                            const payload = {covid : 0}
                            $store.dispatch("SAVE_USER_DATA", payload);
                        } else {
                            $store.dispatch("SAVE_USER_DATA", data);
                        }
                        goNext()
                    } catch (errors) {
                        checkFormValidation(formName, true);
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
        });

        const {
            checkFormValidation,

            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            setCovid,
            formsData,
            checkFormValidation,
            goBack,
            save,
            userData,
            userRole,
            routeName,
            state,
            goNext,
            message
        };
    },
};
</script>
